import { useEffect } from 'react'

import { useResourceHeader } from 'modules/layout/components/ResponsivePage/hooks'

type UpdateHeaderProps = {
  title: string
  description: string
}

export const UpdateHeader = ({ title, description }: UpdateHeaderProps) => {
  const { updateHeader } = useResourceHeader()

  useEffect(() => {
    updateHeader((header) => ({
      ...(header && { ...header }),
      title,
      description,
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description])

  return null
}
